import React from 'react';
import { withFormsy } from 'formsy-react';
import './validators';
import TextField from '@material-ui/core/TextField';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import styled from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';
import { navy, redBrick, darkTaupe, sansSerif } from '../../const';

const theme = createMuiTheme({
  palette: {
    primary: { main: navy },
    error: { main: redBrick }
  }
});

const StyledTextField = styled(TextField)`
  label.focused {
    color: ${navy};
  }
  .MuiInputLabel-outlined {
    transform: translate(14px, 17px) scale(1);
    font-family: ${sansSerif}, sans-serif;
    color: ${darkTaupe};
  }
  .MuiOutlinedInput-root {
    font-family: ${sansSerif}, sans-serif;

    background: white;
    color: ${navy};
    fieldset {
      border-color: ${darkTaupe};
    }

    &.Mui-error fieldset {
      border-color: ${redBrick} !important;
      border-width: 2px;
    }

    &.Mui-focused input {
      color: ${navy};
    }

    &.Mui-error input {
      color: ${redBrick};
    }

    &:hover fieldset {
      border-color: ${darkTaupe};
      border-width: 2px;
    }
    &.Mui-focused fieldset {
      border-color: ${navy};
      border-width: 2px;
    }
    input {
      background-color: white;
      padding: 15.1px 12px;
      border-radius: 5px;
      line-height: 18px;
    }
  }
  .MuiOutlinedInput-multiline {
    background-color: white;
    padding: 15.1px 12px;
    border-radius: 5px;
    line-height: 18px;
  }
`;

class FormsyInputMui extends React.Component {
  state = {
    isPlaceholder: true
  };

  render = () => {
    //todo: performance enhancements
    const {
      type,
      value,
      name,
      showValid,
      isValid,
      isPristine,
      placeholder,
      errorMessages,
      showError,
      autoComplete,
      className = 'input__group',
      multiline = false,
      rowsMax = 1,
      disabled = false
    } = this.props;
    const inputProps = {
      type,
      name,
      value,
      autoComplete,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      multiline,
      rowsMax,
      disabled
    };

    const errors = showError && !isValid ? errorMessages : '';

    let classes = className;
    classes += isValid || isPristine ? '' : ' error';
    classes += showValid === true && isValid ? ' valid' : '';
    classes +=
      this.state.isPlaceholder && (value === '' || value === undefined)
        ? ''
        : ' label';

    return (
      <div className={classes}>
        <div className="input__wrap">
          <ThemeProvider theme={theme}>
            <StyledTextField
              id="outlined-basic"
              style={{ width: '100%' }}
              label={placeholder}
              variant="outlined"
              {...inputProps}
              error={showError && !isValid}
            />
          </ThemeProvider>
          {this.renderSuccessIcon(classes)}
        </div>

        <span className="input__error">{errors}</span>
      </div>
    );
  };

  handleChange = e => {
    if ('mask' in this.props) {
      e.target.value = this.props.mask(e.target.value);
    }

    if ('onChange' in this.props) this.props.onChange(e);
    if ('setValue' in this.props)
      this.props.setValue(
        e.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value']
      );
  };

  handleBlur = e => {
    if ('onBlur' in this.props) this.props.onBlur(e);
    this.setState({ isPlaceholder: true });
  };

  handleFocus = e => {
    if ('onFocus' in this.props) this.props.onFocus(e);
    this.setState({ isPlaceholder: false });
  };

  renderSuccessIcon(classes) {
    if (classes.includes('valid'))
      return (
        <div className="input-icon-wrap">
          <svg
            className="input-icon input-icon__success"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 10"
          >
            <title>Input Success</title>
            <path className="stroke booger" d="M1.2,5.1l4.2,4.6l8.2-9.2" />
          </svg>
        </div>
      );
  }
}

export default withFormsy(FormsyInputMui);



// WEBPACK FOOTER //
// ./src/components/form/FormsyInputMui.js